import React, { useState } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

const AddEditLeaveRequest = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});

  const [leaveData, setLeaveData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    leave_date: '',
    remark: '',
  });

  const onChangeHandle = (e) => {
    const { name, value } = e.target;

    setLeaveData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const SaveLeaveRequest = async () => {
    if (
      isSuperAdmin &&
      (!leaveData.vendor_id || Number(leaveData.vendor_id) <= 0)
    ) {
      toast.error('Please select Vendor');
      return;
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!leaveData.branch_id || Number(leaveData.branch_id) <= 0)
    ) {
      toast.error('Please select Branch');
      return;
    }

    if (!leaveData.leave_date) {
      toast.error('Please select Leave Date');
      return;
    }

    if (!leaveData.remark || !leaveData.remark.trim()) {
      toast.error('Please enter Reason / Remark');
      return;
    }

    try {
      const vendorId = leaveData.vendor_id || '';
      const branchId = leaveData.branch_id || '';

      const payload = {
        leave_date: leaveData.leave_date,
        remark: leaveData.remark,
      };

      const res = await apiService.post(
        `api/AttendanceMaster/save-leave?vendorId=${vendorId}&branchId=${branchId}`,
        payload,
      );

      if (res?.status === true) {
        toast.success(res.message);
        navigate('/leave-request-list');
      } else {
        toast.error(res?.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={leaveData}
        setSelectionData={setLeaveData}
        accessButton={true}
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Leave Request Form</span>
          <Button color='warning' onClick={() => navigate(-1)}>
            <i className='bi bi-arrow-left' />
          </Button>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Leave Date</Label>
              <Input
                type='date'
                name='leave_date'
                value={leaveData.leave_date || ''}
                onChange={onChangeHandle}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Status</Label>
              <Input type='text' value='Pending' disabled />
            </FormGroup>

            <FormGroup className='col-sm-12'>
              <Label>Reason / Remark</Label>
              <Input
                type='textarea'
                name='remark'
                rows='4'
                value={leaveData.remark || ''}
                onChange={onChangeHandle}
                placeholder='Enter leave reason'
              />
            </FormGroup>
          </Row>

          <Button
            color='primary'
            className='float-end mt-3'
            onClick={SaveLeaveRequest}
          >
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditLeaveRequest;